import { ModalFooter } from 'reactstrap'

function CustomModalFooter({ children, start = true }) {
  return (
    <ModalFooter
      className={`d-flex ${
        start ? 'justify-content-start' : 'justify-content-end'
      } pl-4`}
    >
      {children}
    </ModalFooter>
  )
}

export default CustomModalFooter
